import React, { Component } from 'react';  
import { connect } from 'react-redux';
import { getEncyclopedia, encyclopediaAction } from "../../action/investmentAction.js";
import NavigatorMain from '../NavigatorMain.js';
import { hashHistory } from 'react-router';

class Encyclopedia extends Component {
  state = {
    listSource: null
  }

  componentWillMount () {
    document.getElementsByTagName('title')[0].innerHTML = "智投百科";
    let { dispatch } = this.props;
    this.setState({
      listSource: null
    });
    dispatch(encyclopediaAction(null));
    dispatch(getEncyclopedia({
      code: "wt_zt2"
    }, (data) => {
      this.setState({
        listSource: [].concat(data.content.rows)
      });
    }));
  }

  goBack = () => {
     hashHistory.goBack();
  }

  goDetail = (content) => {
    hashHistory.push({
      pathname: "/encyclopediaDetail",
      state: {
        content: content
      }
     });
  }

  render() {
    let { listSource } = this.state; 
    let { encyclopediaAction } = this.props;
    let contentArray = [];
    if(listSource != null) {
      for(let i = 0; i < listSource.length; i++) {
        for(let k = i + 1; k < listSource.length; k++) {
          if(listSource[i].bq[0].tagId == listSource[k].bq[0].tagId) {
            listSource.splice(k, 1);
          }
        }
      }
      if(encyclopediaAction != null) {
        for(let s = 0; s < listSource.length; s++) {
          contentArray.push(
            <div key={s} style={{
              height: 50,
              paddingTop: 25,
              paddingLeft: 13,
              paddingRight: 13
            }}>
              <span style={{
                color: "#3a3e47",
                fontSize: "13px"
              }}>{listSource[s].bq[0].tagName}</span>
            </div>
          );
          for(let h = 0; h < encyclopediaAction.length; h++) {
            if(listSource[s].bq[0].tagId == encyclopediaAction[h].bq[0].tagId) {
              contentArray.push(
                <div key={encyclopediaAction[h].bq[0].cjwtId}>
                  <div onClick={() => this.goDetail(encyclopediaAction[h].title)} style={{
                    display: "-webkit-flex",
                    height: 45,
                    paddingLeft: 13,
                    paddingRight: 6.5,
                    backgroundColor: "#fff",
                    borderBottom: "1px solid rgb(235, 238, 240)",
                    WebkitJustifyContent: "space-between",
                    WebkitAlignItems: "center",
                    WebkitFlexDirection: "row",
                    WebkitFlexWrap: "wrap"
                  }}>
                      <span dangerouslySetInnerHTML={{__html: encyclopediaAction[h].title}} style={{
                        color: "#3a3e47",
                        fontSize: 12
                      }}></span>
                      <img
                      src = {require('../../img/my_assets_item_foot.png')}
                      style={{
                        width: 22,
                        height: 44
                      }}
                      />
                  </div>
                </div>
              );
            }
          }
        }
      }
    }
    return (
      <div style={{background: "#fff", display: "-webkit-flex", WebkitFlexDirection: "column", height: "100%"}}>
        <NavigatorMain>
          <div style={{background: "rgb(38, 42, 48)", display: "-webkit-flex", height: 44, WebkitAlignItems: "center", WebkitFlexDirection: "row", WebkitJustifyContent: "space-between"}}>
            <div style={{width: 100}}>
              <img onClick={this.goBack}  alt="" style={{height: 40, width: 40}} src={require("../../img/leftArrow_header.png")} />
            </div>
            <div style={{fontSize: 15, color: "#fff", WebkitFlex: 1, textAlign: "center"}}>智投百科</div>
            <div style={{fontSize: 15, color: "#fff", paddingRight: 13, width: 100, textAlign: "right"}}></div>
          </div>
        </NavigatorMain>
        <div style={{WebkitFlex: 1, overflow: "auto", background: "rgba(242,245,247,1)"}}>
          {
            encyclopediaAction != null ?
            contentArray :
            null
          }
        </div>
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    encyclopediaAction: state.encyclopediaAction
  }
}

export default connect(mapStateToProps)(Encyclopedia);


// WEBPACK FOOTER //
// ./src/components/recommend/Encyclopedia.js